import { uri } from '../../api-endpoint';
import { ICompanyFromAPISuccessResponse } from '../../type-conversion/company/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchCompanyListAPI = (token: string) => (koumutenId: number) =>
  fetchListTemplateFn(
    token,
    uri.companyListOfKoumuten(koumutenId),
    ICompanyFromAPISuccessResponse
  );
